<!--
 * @Description: 完善信息
 * @Author: yl
 * @Date: 2021-05-31 11:34:32
 * @LastEditTime: 2021-06-16 16:42:28
 * @LastEditors: yl
-->
<template>
    <van-dialog class="lotteryInfo" v-model="dialog" :title="title ? title : '提交信息'" :closeOnClickOverlay="false"
        :closeOnPopstate="false" :showConfirmButton='false' @cancel='closeDialog'>
        <div class="form">
            <div class='bv'>
                <!-- <validation-observer ref="form" v-slot="{ invalid }"> -->
                <validation-observer ref="form">
                    <validation-provider rules="required|mobile" name="手机号码" v-slot="{ errors }">
                        <van-field label="手机号" label-width='5rem' v-model="info.telephone" clearable keyboard="number"
                            maxlength="11" readonly placeholder="请输入手机号码">
                            <zb-warning slot="right-icon" :message="errors[0]" />
                        </van-field>
                    </validation-provider>
                    <validation-provider rules="required|max:6|alpha_num" name="身份证号" v-slot="{ errors }">
                        <van-field label="身份证号" label-width='5rem' v-model="info.idCard" clearable maxlength="6"
                            placeholder="请正确填写身份证号后六位" keyboard="number">
                            <zb-warning slot="right-icon" :message="errors[0]" />
                        </van-field>
                    </validation-provider>
                    <div class="btnArea bh bbetween">
                        <van-button class="btn cancel fz_28" @click="closeDialog">取消</van-button>
                        <!-- <van-button class="btn pass fz_28" :disabled="invalid || !info" @click="submit">确认</van-button> -->
                        <van-button class="btn pass fz_28" @click="submit(data)">确认</van-button>
                    </div>
                </validation-observer>
            </div>
        </div>
    </van-dialog>
</template>

<script>
import util from '@/utils/index'
import { mixinValid } from "@/mixin/valid";
import { inputInfo, updateInfo } from "@/api/lottery";
export default {
    mixins: [mixinValid],
    components: {},
    name: "",
    props: {
        dialog: null,
        title: null,
        data: null
    },
    watch: {
        dialog: {
            handler(v) {
                if (v && this.data) this.info = { ...this.data, telephone: this.$store.state.userInfo.telephone }
                // console.log(this.data, this.info)
            },
            immediate: false,
            deep: true
        }
    },
    data() {
        return {
            info: {
                telephone: '',
                idCard: ''
            }
        };
    },
    methods: {
        submit({ idCard }) {
            if (idCard) util.limiting(this.update, null, 3000);
            else util.limiting(this.save, null, 3000);
        },
        // 第一次完善信息
        save() {
            this.validForm().then(() => {
                const params = {
                    ...this.info,
                    H5Authorization: this.$store.state.h5authorization
                }
                inputInfo(params).then(res => {
                    const { data } = res
                    this.toast.success(`恭喜你获得${data.numberOfLuckyDraw}次抽奖机会`)
                    this.$emit('getInfo', { ...this.info, ...data })
                    this.closeDialog()
                })
            });
        },
        // 修改信息
        update() {
            this.validForm().then(() => {
                const params = {
                    ...this.info,
                    H5Authorization: this.$store.state.h5authorization
                }
                updateInfo(params).then(res => {
                    const { data } = res
                    data.numberOfLuckyDraw && this.toast.success(`恭喜你获得${data.numberOfLuckyDraw}次抽奖机会`);
                    this.$emit('getInfo', { ...this.info, ...data })
                    this.closeDialog()
                })
            });
        },
        closeDialog() {
            this.$emit('update:dialog', false)
        }
    }
};
</script>

<style scoped lang="scss">
.lotteryInfo {
    ::v-deep .van-dialog__footer {
        display: none;
    }

    .btnArea {
        border-top: 1px solid #ebedf0;
        .btn {
            height: 90px;
            width: 100%;
            border: none;
        }
        .pass {
            color: #ee0a24;
        }
        .cancel {
            border-right: 1px solid #ebedf0;
        }
    }
}
</style>